import './groups_view.js.coffee';# Added by Script 
class Customer.Filters.ResponseTemplateGroupsView extends Customer.Filters.GroupsView

  initialize: (@options = {}) ->
    super
    @keywordsFilterView = new Monitoring.Views.SocialContents.Filters.ResponseTemplateCustomerGroupsFilterView
      terms: @terms
      customerFilter: @customerFilter
      useCustomValues: @options.useCustomValues
